import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Lock({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Lock.Outline {...props} /> : <Lock.Solid {...props} />;
}

Lock.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M12.6128 14.2029C12.6128 13.7887 12.277 13.4529 11.8628 13.4529C11.4486 13.4529 11.1128 13.7887 11.1128 14.2029V16.4239C11.1128 16.8381 11.4486 17.1739 11.8628 17.1739C12.277 17.1739 12.6128 16.8381 12.6128 16.4239V14.2029Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.5525 7.27776C6.56531 4.35017 8.9476 1.98813 11.8741 2.00004C14.8006 2.00093 17.1735 4.37438 17.1735 7.30104V8.87705C18.9498 9.49366 20.2252 11.1818 20.2252 13.169V17.458C20.2252 19.9673 18.1913 22 15.6832 22H8.04224C5.53416 22 3.50024 19.9673 3.50024 17.458V13.169C3.50024 11.1817 4.77591 9.49334 6.55249 8.87687L6.5525 7.27776ZM11.8725 3.50004C13.9713 3.50004 15.6735 5.20226 15.6735 7.30104V8.62695H8.05249V7.28276C8.06252 5.18363 9.77101 3.49086 11.8692 3.50004H11.8725ZM8.04224 10.127C6.36233 10.127 5.00024 11.4883 5.00024 13.169V17.458C5.00024 19.1386 6.36233 20.5 8.04224 20.5H15.6832C17.3632 20.5 18.7252 19.1386 18.7252 17.458V13.169C18.7252 11.4883 17.3632 10.127 15.6832 10.127H8.04224Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Lock.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          id="Fill 1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.92651 8.84613H16.3889C18.7464 8.84613 20.6577 10.7153 20.6577 13.0208V17.9576C20.6577 20.2631 18.7464 22.1323 16.3889 22.1323H7.92651C5.56907 22.1323 3.65771 20.2631 3.65771 17.9576V13.0208C3.65771 10.7153 5.56907 8.84613 7.92651 8.84613ZM12.1526 17.4618C12.6505 17.4618 13.0468 17.0742 13.0468 16.5873V14.3812C13.0468 13.9042 12.6505 13.5167 12.1526 13.5167C11.6649 13.5167 11.2686 13.9042 11.2686 14.3812V16.5873C11.2686 17.0742 11.6649 17.4618 12.1526 17.4618Z"
          className="icon-primary"
        />
        <path
          id="Fill 4"
          opacity="0.4"
          d="M17.6807 7.52828V8.999C17.325 8.89962 16.9491 8.84994 16.5629 8.84994H15.9024V7.52828C15.9024 5.511 14.2258 3.87135 12.163 3.87135C10.1003 3.87135 8.42366 5.50107 8.4135 7.5084V8.84994H7.76317C7.36687 8.84994 6.9909 8.89962 6.63525 9.00893V7.52828C6.64542 4.54709 9.11463 2.13232 12.1427 2.13232C15.2115 2.13232 17.6807 4.54709 17.6807 7.52828Z"
          className="icon-secondary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
